
export default {
    spacingDebug: true,
    props: {
        embedded: { type: Boolean, default: false },
        sectionId: { type: String, default: "uvp-listing" },
        payload: { type: Object, default: () => ({}) },
    },
    computed: {
        items() {
            const items = this.payload?.body?.items;
            return Array.isArray(items) ? items.filter((item) => typeof item === "string" && item.trim()) : [];
        },
    },
};
